// refer here for their API reference https://www.npmjs.com/package/@frontend-sdk/klaviyo

export function subscribe(listId, email, params = {}) {
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

  var urlencoded = new URLSearchParams();
  urlencoded.append('g', listId);
  urlencoded.append('email', email);

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow',
  };

  return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', requestOptions)
    .then((response) => response.json())
    .catch((error) => console.error('error', error));
}
